import {useMutation} from '@tanstack/react-query'
import {useUpdateOrderApiMethod} from 'api/useUpdateOrderApiMethod'
import {get} from 'lodash'
import {Params} from 'types'
import addTrackingError, {addTrackingException} from 'utils/addTrackingError'
import {delay} from 'utils/delay'

const MAX_TOO_MANY_REQUESTS = 3
const DEFAULT_DELAY = 3

export const useUpdateOrderMutation = () => {
  const updateOrder = useUpdateOrderApiMethod()

  return useMutation({
    mutationFn: async ({orderId, ...updateParams}: Params.UpdateOrderRequest) => {
      let retriesTooManyRequests = 1

      while (true) {
        try {
          return await updateOrder({orderId, ...updateParams})
        } catch (error: any) {
          // If Ventrata is just failing to process the request:
          if (get(error, 'response.data.error') === 'TOO_MANY_REQUESTS') {
            addTrackingError('Ventrata: TOO_MANY_REQUESTS', {
              level: 'error',
              action: 'updateOrder',
              order: orderId,
              retries: retriesTooManyRequests,
              retryAfter: get(error, 'response.data.retryAfter'),
            })

            if (retriesTooManyRequests >= MAX_TOO_MANY_REQUESTS) {
              addTrackingException(error, {action: 'updateOrder', order: orderId})
              throw error
            }

            retriesTooManyRequests++

            let thisDelay = DEFAULT_DELAY
            let retryAfter = get(error, 'response.data.retryAfter')

            if (retryAfter) {
              thisDelay = retryAfter
            }

            await delay(thisDelay * 1000)
            continue
          }

          throw error
        }
      }
    },
  })
}
